import { Record, Set, fromJS, List } from "immutable";
import { SITE_TYPES } from "@infinode/constants/site";
import DataSourceRecord from "./DataSourceRecord";
import DataSourceValueRecord from "./DataSourceValueRecord";

const SiteRecord = Record({
  id: null,
  key: null,
  name: "",
  streetAddress: "",
  suburb: "",
  state: "",
  country: "",
  postcode: "",
  siteType: SITE_TYPES.SINGLE_ZONE,
  description: null,

  //embedded nw
  limiter:'flat',
  isDemandSideManagementEnabled:false,
  isGridFeedinManagementEnabled: false,
  demandLimit:0,
  demandLimitUnit:0,
  exportLimit:0,
  exportLimitUnit:0,
  CSIPHostServer:null,
  DcapURI:null,
  NMI:null,
  siteIPV4:null,
  centralControllerType:null,
  connectionStatus:null,
  lastMappingCommitTimestampSec: null,

  // mappingCommitFlag:0,

  dataSource: DataSourceRecord(),

  //tariff general
  tariffType:"",
  // demand
  demandOn: false,
  demandThreshold: 0,
  //tariff
  flatRate:null,
  blockThreshold:null,
  block1Rate:null,
  block2Rate:null,
  TOUWeekdaySession1StartHour:null, 
  TOUWeekdaySession1StartMinute:null,
  TOUWeekdaySession1StopHour:null,
  TOUWeekdaySession1StopMinute:null,

  TOUWeekdaySession2StartHour:null,
  TOUWeekdaySession2StartMinute:null,
  TOUWeekdaySession2StopHour:null,
  TOUWeekdaySession2StopMinute:null,

  TOUWeekdaySession3StartHour:null,
  TOUWeekdaySession3StartMinute:null,
  TOUWeekdaySession3StopHour:null,
  TOUWeekdaySession3StopMinute:null,


  TOUWeekdaySession1Rate:null,
  TOUWeekdaySession2Rate:null,
  TOUWeekdaySession3Rate:null,

  TOUWeekendSession1StartHour:null,
  TOUWeekendSession1StartMinute:null,
  TOUWeekendSession1StopHour:null,
  TOUWeekendSession1StopMinute:null,

  TOUWeekendSession2StartHour:null,
  TOUWeekendSession2StartMinute:null,
  TOUWeekendSession2StopHour:null,
  TOUWeekendSession2StopMinute:null,

  TOUWeekendSession3StartHour:null,
  TOUWeekendSession3StartMinute:null,
  TOUWeekendSession3StopHour:null,
  TOUWeekendSession3StopMinute:null,


  TOUWeekendSession1Rate:null,
  TOUWeekendSession2Rate:null,
  TOUWeekendSession3Rate:null,
  // Ids
  zones: Set(),
  // Ids
  users: Set()
});

const createSiteRecord = site => {
  let record = SiteRecord(site);
  record = record.withMutations(rm => {
    rm.update("zones", zones => Set(zones ? zones : []));
    rm.update("streetAddress", sa => sa || "");
    rm.set(
      "dataSource",
      DataSourceRecord(
        site.dataSource
          ? fromJS(site.dataSource).map(ds => (ds ? List(ds.map(v => DataSourceValueRecord(v))) : List()))
          : List()
      )
    );
    if (site.siteDemand) {
      rm.set("demandOn", site.siteDemand.isOn);
      rm.set("demandThreshold", site.siteDemand.threshold);
    }
  });
  return record;
};

export { createSiteRecord };

export default SiteRecord;
